module.exports = __webpack_public_path__ + "media/src/images/masks/avatar-group-94242b11fff3efd527fa2fff1fe6dab2.svg";